const SELECT = 'select-option';
const CLEAR = 'clear';

const selected = (action, name) => action.action === SELECT && action.name === name
const cleared = (action, name) => action.action === CLEAR && action.name === name

const season = (state, action) => {
  if (selected(action, 'seasonId')) return action.option;
  if (cleared(action, 'seasonId')) return process.env.CURRENT_SEASON;
  return state.seasonId || process.env.CURRENT_SEASON;
}

const office = (state, action) => {
  if (selected(action, 'officeId')) return action.option;
  if (cleared(action, 'officeId')) return;

  return state.officeId;
}

const divisionId = (state, action) => {
  if (selected(action, 'divisionId')) return action.option;
  if (cleared(action, 'divisionId')) return;
  return state.divisionId;
}

const gender = (state, action) => {
  if (selected(action, 'gender')) return action.option;
  if (cleared(action, 'gender')) return;

  return state.gender;
}

const categoryId = (state, action) => {
  if (selected(action, 'categoryId')) return action.option;
  if (cleared(action, 'categoryId')) return;

  return state.categoryId;
}

const schedule = (state, action) => {
  if (selected(action, 'scheduleId')) return action.option;
  if (cleared(action, 'scheduleId')) return;

  if (selected(action, 'seasonId') && state.seasonId !== action.option) return;
  if (selected(action, 'officeId') && state.officeId !== action.option) return;
  if (selected(action, 'divisionId') && state.divisionId !== action.optionId) return;
  if (selected(action, 'gender') && state.gender !== action.option) return;

  return state.scheduleId;
}

const group = (state, action) => {
  if (selected(action, 'groupId')) return action.option;
  if (cleared(action, 'groupId')) return;

  if (selected(action, 'seasonId') && state.seasonId !== action.option) return;
  if (selected(action, 'officeId') && state.officeId !== action.option) return;
  if (cleared(action, 'officeId')) return;

  if (selected(action, 'scheduleId') && state.scheduleId !== action.option) return;
  if (cleared(action, 'scheduleId')) return;

  return state.groupId;
}

const type = (state, action) => {
  if (selected(action, 'type')) return action.option;
  if (cleared(action, 'type')) return;

  return state.type;
}

export default (state, action) => {
  if (action.action === 'restore') return { ...state, ...action.state, officeId: undefined };
  if (action.action === 'reset') return action.state;
  return {
    seasonId: season(state, action),
    officeId: office(state, action),
    divisionId: divisionId(state, action),
    gender: gender(state, action),
    categoryId: categoryId(state, action),
    scheduleId: schedule(state, action),
    groupId: group(state, action),
    type: type(state, action),
  }
}
